<template>
  <div class="good-card-module">
    <div class="card-wrapper">
      <div class="card center mobile-only" :class="{active: activeCard === 1}" ref="mobilecard0">
        <img src="../assets/images/mobile/元素.svg" alt="" class="bg bg1 mobile-only">
        <img src="../assets/images/mobile/元素liner.svg" alt="" class="bg bg2 mobile-only">
        <div class="content1">系统及软件的升级配合专业服务 <br> 让企业成长没有后顾之忧</div>
        <div class="content2">成长<br class="mobile-only">加速包</div>
        <div class="content3">Office 365 云办公方案 <br>线上IT资产盘点 <br>工程师技术服务日</div>
        <div class="line mobile-only"></div>
        <a :href="registerLink" target="_blank" class="learn-more mobile-only">
          <img src="../assets/images/mobile/button.svg" alt="" class="button1">
          <img src="../assets/images/mobile/button2.svg" alt="" class="button2">
        </a>
        <div class="learn-more pc-only">
          <!--<span class="pc-only">了解更多</span>-->
          <img src="../assets/images/png/thinkpad-qrcode.png" alt="" class="qrcode">
        </div>
        <div class="tip pc-only">扫描二维码 了解详情</div>
      </div>
      <div class="card left" :class="{active: activeCard === 0}" ref="mobilecard1"
           @mouseenter="setActiveCard(0)"
           @mouseleave="setActiveCard(1)">
        <img src="../assets/images/mobile/元素.svg" alt="" class="bg bg1 mobile-only">
        <img src="../assets/images/mobile/元素liner.svg" alt="" class="bg bg2 mobile-only">
        <div class="content1">更优惠地购买设备及软件 <br> 让企业基础配置创建更轻松</div>
        <div class="content2">初创<br class="mobile-only">支持包</div>
        <div class="content3">专项价购新机 <br>专享价购办公软件 <br>延保服务</div>
        <div class="line mobile-only"></div>
        <a :href="registerLink" target="_blank" class="learn-more mobile-only">
          <img src="../assets/images/mobile/button.svg" alt="" class="button1">
          <img src="../assets/images/mobile/button2.svg" alt="" class="button2">
        </a>
        <div class="learn-more pc-only">
          <!--<span class="pc-only">了解更多</span>-->
          <img src="../assets/images/png/thinkpad-qrcode.png" alt="" class="qrcode">
        </div>
        <div class="tip pc-only">扫描二维码 了解详情</div>
      </div>
      <div class="card center pc-only"
           :class="{active: activeCard === 1, 'left-active': activeCard === 0, 'right-active': activeCard}"
           @mouseenter="setActiveCard(1)"
           @mouseleave="setActiveCard(1)">
        <img src="../assets/images/mobile/元素.svg" alt="" class="bg bg1 mobile-only">
        <img src="../assets/images/mobile/元素liner.svg" alt="" class="bg bg2 mobile-only">
        <div class="content1">系统及软件的升级配合专业服务 <br> 让企业成长没有后顾之忧</div>
        <div class="content2">成长<br class="mobile-only">加速包</div>
        <div class="content3">Office 365 云办公方案 <br>线上IT资产盘点 <br>工程师技术服务日</div>
        <div class="line mobile-only"></div>
        <a :href="registerLink" target="_blank" class="learn-more mobile-only">
          <img src="../assets/images/mobile/button.svg" alt="" class="button1">
          <img src="../assets/images/mobile/button2.svg" alt="" class="button2">
        </a>
        <div class="learn-more pc-only">
          <!--<span class="pc-only">了解更多</span>-->
          <img src="../assets/images/png/thinkpad-qrcode.png" alt="" class="qrcode">
        </div>
        <div class="tip pc-only">扫描二维码 了解详情</div>
      </div>
      <div class="card right" :class="{active: activeCard === 2}" ref="mobilecard2"
           @mouseenter="setActiveCard(2)"
           @mouseleave="setActiveCard(1)">
        <img src="../assets/images/mobile/元素.svg" alt="" class="bg bg1 mobile-only">
        <img src="../assets/images/mobile/元素liner.svg" alt="" class="bg bg2 mobile-only">
        <div class="content1">一站式的售后服务和个性化定制 <br> 让企业管理更便捷更全面</div>
        <div class="content2">平稳<br class="mobile-only">提升包</div>
        <div class="content3">一站式售后管家 <br>电脑 A 面订制 <br>旧机回收</div>
        <div class="line mobile-only"></div>
        <a :href="registerLink" target="_blank" class="learn-more mobile-only">
          <img src="../assets/images/mobile/button.svg" alt="" class="button1">
          <img src="../assets/images/mobile/button2.svg" alt="" class="button2">
        </a>
        <div class="learn-more pc-only">
          <!--<span class="pc-only">了解更多</span>-->
          <img src="../assets/images/png/thinkpad-qrcode.png" alt="" class="qrcode">
        </div>
        <div class="tip pc-only">扫描二维码 了解详情</div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodCard',
  data () {
    return {
      activeCard: 1,
      registerLink: 'https://reg.lenovo.com.cn/auth/member/cardPage?ticket=b164f797-d5e7-47e4-be28-a3af7bb1eb78&ru=https%3a%2f%2fm.thinkpad.com%2fwap%2factivity%2fSMB&pmf_group=SMB&pmf_medium=180725jike&pmf_source=Z00003969T000'
    }
  },
  methods: {
    setActiveCard (id) {
      this.activeCard = id
    }
  }
}
</script>

<style lang="stylus" scoped>
.clearfix
  clearfix()

@media screen and (min-width: 1201px)
  .good-card-module
    position relative
    .card-wrapper
      position relative
      margin 0 auto
      width 932px + 6px
      .card
        position relative
        $border-radius = 7px
        float left
        &.left, &.right, &.center
          width 306px
          height 440px
          margin-top 49px
          border 1px solid #979797
        &.left
          border-radius $border-radius 0 0 $border-radius
          border-right none
        &.right
          border-radius 0 $border-radius $border-radius 0
          border-left none
        &.center
          &.left-active
            border-left none
          &.right-active
            border-right none
        &.active
          border none
          margin-top 0
          width 320px
          height 516px
          background linear-gradient(#FF5B56, #A50E09)
          border-radius $border-radius
          .content1
            margin-top 79px
          .content2
            color #fff
            font-size 24px
            line-height 33px
          .content3
            color #fff
          .learn-more
            bottom 53px + 27px
            left 115px + 7px
            background-color #fff
            color #E61211
          .tip
            bottom 23px + 27px
        .content1
          margin-top 53px
          padding 0 50px
          font-size 12px
          line-height 24px
          color rgba(255, 255, 255, 0.6)
        .content2
          margin-top 30px
          padding 0 50px
          letter-spacing 4px
          font-size 20px
          line-height 28px
          color #9B9B9B
        .content3
          margin-top 30px
          padding 0 50px
          font-size 14px
          line-height 24px
          color #666666
        // .learn-more // 原来按钮的样式
        //  position absolute
        //  left 85px
        //  bottom 53px
        //  width 136px
        //  height 46px
        //  border 2px solid #bdbdbd
        //  border-radius 40px
        //  font-size 12px
        //  color #fff
        //  line-height @height
        //  text-decoration none
        .learn-more // 二维码样式
          position absolute
          left 115px
          bottom 53px
          width 80px
          height @width
          font-size 12px
          color #fff
          line-height @height
          text-decoration none
          .qrcode
            width @width
            height @width
        .tip
          position absolute
          width 100%
          left 0
          bottom 23px
          font-size 12px
          color rgba(255, 255, 255, 0.7)
@media screen and (max-width: 1200px)
  .good-card-module
    position relative
    .card-wrapper
      width 100%
      .card
        position relative
        margin 0 auto
        width 10.14rem
        height 4.90rem
        margin-bottom 0.32rem
        border-radius 0.3rem
        border 1px solid #979797
        &.mobile-center
          background linear-gradient(#FF5B56, #A50E09)
          border 0 solid #979797
          .bg
            &.bg1
              display block !important
            &.bg2
              display none !important
          .learn-more
            img
              &.button1
                display block !important
              &.button2
                display none !important
        .bg
          position absolute
          width 8.61rem
          height 3.95rem
          left 0.34rem
          top 0.27rem
          &.bg1
            display none !important
        .learn-more
          position absolute
          top 0
          left 0
          width 1.12rem
          height @width
          padding 1.89rem 0 1.89rem 9.6rem
          img
            width @width
            height @width
            &.button1
              display none !important
        .line
          position absolute
          width 0.03rem
          height 3.55rem
          left 3.86rem
          top 0.67rem
          background-color rgba(255, 255, 255, 0.7)
        .content2
          position absolute
          top 1.38rem
          left 0.37rem
          width 3.07rem
          height 2.14rem
          font-size 0.77rem
          line-height 1.07rem
          text-align right
          letter-spacing 0.2rem
        .content1
          position absolute
          top 0.85rem
          left 4.35rem
          width 5.38rem
          height 1.15rem
          font-size 0.38rem
          line-height 0.58rem
          color rgba(255, 255, 255, 0.7)
        .content3
          position absolute
          top 2.27rem
          left 4.35rem
          width 5.38rem
          height 2.14rem
          font-size 0.38rem
          line-height 0.58rem
</style>



// WEBPACK FOOTER //
// src/components/GoodCard.vue